module.exports = __webpack_public_path__ + "img/syukyaku-top-007.106c312e.jpg";